import isEmpty from 'lodash/isEmpty'
import {
  SOURCE_TYPES,
  NOTEBOOK_PARAMETER_NAMES,
} from '../../../schedulerModal/config/constants'

export const formatOptions = (item) => {
  if (!isEmpty(item)) {
    return {
      text: item.name,
      value: item?.id,
    }
  }

  return {
    text: '',
    value: '',
  }
}

export const getParameterLabel = (
  sourceType,
  translate,
  parameterName,
  option
) => {
  if (parameterName === NOTEBOOK_PARAMETER_NAMES.data_set) {
    return translate(`scheduler.modal.parameters.${option}datasets.label`)
  }
  return sourceType === SOURCE_TYPES.list
    ? translate(`scheduler.modal.parameters.${option}lists.label`)
    : translate(`scheduler.modal.parameters.${option}search.label`)
}

export const mapOptions = (options, parameterName, sourceType, translate) => {
  if (isEmpty(options)) {
    return []
  }

  return [
    {
      text: getParameterLabel(sourceType, translate, parameterName, 'user'),
      children: [...options.user.map((option) => formatOptions(option))],
    },
    {
      text: getParameterLabel(
        sourceType,
        translate,
        parameterName,
        'morningstar'
      ),
      children: [...options.morningstar.map((option) => formatOptions(option))],
    },
  ]
}

export const getInvestmentItemText = (id, options = []) => {
  if (!options.length) {
    return
  }
  const children_options = [...options[0].children, ...options[1].children]

  return children_options.find(({ value }) => value === id).text
}
